import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-atlas-checkout-cancel',
  templateUrl: './atlas-checkout-cancel.component.html',
  standalone: false,
})
export class AtlasCheckoutCancelComponent implements OnInit {
  public returnToSubscriptionUrl = '/atlas/subscribe';
  public tenantId: string | null = null;
  public returnUrl: string | null = null;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.tenantId = this.route.snapshot.queryParamMap.get('tenantId');
    if (this.tenantId) {
      this.returnToSubscriptionUrl = `/atlas/subscribe?${new URLSearchParams({ tenantId: this.tenantId }).toString()}`;
    } else {
      this.returnUrl = document.referrer || null;
    }
  }
}
